export const uiHeader = {
    name: 'UI Header',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        appearance: {
            name: 'Appearance',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    in: [
                        'Blue',
                        'Purple',
                        'Pink',
                        'Gray',
                        'Lavender',
                        'Dark Gray',
                        'White'
                    ]
                }
            ]
        },
        logInText: {
            name: 'Log in text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        signUpText: {
            name: 'Sign up text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        goToBoardsText: {
            name: 'Go to boards text',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        showNewLogo: {
            name: 'Show New Logo',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiHeader.js.map